import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-850db3cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "x-container" }
const _hoisted_4 = { class: "header__content" }
const _hoisted_5 = { class: "slider__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_StoriesSlider = _resolveComponent("StoriesSlider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "header__logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
          }, [
            _createVNode(_component_Icon, { name: "logo" })
          ]),
          _createElementVNode("button", {
            class: "header__close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
          }, [
            _createVNode(_component_Icon, { name: "close" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_StoriesSlider)
    ])
  ]))
}